/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { Errors } from 'state/shared/types';

import type { SignInDto, SignInFailure } from './signInTypes';

export type SliceState = {
  pending: boolean;
  errors: Errors;
};

export const initialState: SliceState = {
  pending: false,
  errors: [],
};

const signInSlice = createSlice({
  name: 'signIn',
  initialState,
  reducers: {
    SIGN_IN_REQUEST(state, _action: PayloadAction<SignInDto>) {
      state.pending = true;
      state.errors = [];
    },
    SIGN_IN_SUCCESS(state, _action: PayloadAction) {
      /* Fix for slow redirects (spinner continues when sign in
       * was successful but waiting for redirect)
       */
      // state.pending = false;
      state.errors = [];
    },
    SIGN_IN_FAILURE(state, action: PayloadAction<SignInFailure>) {
      state.pending = false;
      state.errors.push(action.payload);
    },
  },
});

export const signInActions = signInSlice.actions;

export default signInSlice.reducer;
